// Re-export existing utilities
export { calculatePrecisionFromDateRange } from './period';
export { useGetPreviousIntervalRange } from './intervalRange';

// Export from dates.ts (local implementations)
export { getDefaultIntervalRange, getPreviousIntervalRange } from './dates';

// Export date formatting utilities
export { formatDateByPrecision } from './dateFormatting';

// Export data validation utilities
export {
  isDataNull,
  isNestedValueNull,
  isHighlightDataMissing,
  isMetricDataMissing,
  isChartDataMissing,
} from './dataValidation';
